import {Error} from "@mui/icons-material";
import {Alert} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";


export default function APXErrorAlert(props) {
	  return (
				 <>
						<Alert icon={<Error fontSize={"inherit"}/>} severity="error" variant={"outlined"} sx={{m: 2, alignItems: "center"}}>
							  {props.message}
						</Alert>
				 </>
	  );
}


export function useErrorAlert(deps) {
	  const [show, setShow] = useState(false);
	  
	  const callback = useCallback(() => {
			 setTimeout(() => {
					setShow(false);
			 }, 50);
	  }, []);
	  
	  useEffect(callback, [...deps, callback]);
	  
	  return [show, setShow];
}